import React from "react";
import { Box, Typography } from "@mui/material";
import { Clock3, Trophy } from "lucide-react";
import { AssessmentQuestionWinner } from "../../../axios/quiz";
import {
  containerStyle,
  iconStyle,
  metaRowStyle,
  metaTextStyle,
  rowStyle,
  separatorStyle,
  textStyle,
} from "./styles";

interface AssessmentQuestionWinnerCardProps {
  questionWinner?: AssessmentQuestionWinner | null;
}

export const AssessmentQuestionWinnerCard = ({
  questionWinner,
}: AssessmentQuestionWinnerCardProps) => {
  if (!questionWinner) {
    return null;
  }

  const formattedWinnerTime = questionWinner.time_spent
    .toFixed(1)
    .replace(/\.0$/, "");

  return (
    <Box sx={containerStyle}>
      <Box sx={rowStyle}>
        <Box sx={iconStyle}>
          <Trophy size={16} />
        </Box>
        <Typography sx={textStyle}>
          {`Question Winner: ${questionWinner.name}`}
        </Typography>
        <Box sx={separatorStyle} />
      </Box>
      <Box sx={metaRowStyle}>
        <Clock3 size={14} />
        <Typography sx={metaTextStyle}>
          {`Fastest correct answer: ${formattedWinnerTime} sec`}
        </Typography>
      </Box>
    </Box>
  );
};

export default AssessmentQuestionWinnerCard;
